"use strict";

var React = require('react');

var _ = require('lodash');

var Divider = require('../divider');

var Tooltip = require('../tooltip');

var TextLabel = require('../textLabel');

var RadioButton = require('../radioButton');

function repeatOption1(selectedValue, option) {
  var _this = this;

  return /*#__PURE__*/React.createElement("div", {
    key: 'option-' + option.value,
    className: "tab",
    "data-hook": option.dataHook
  }, /*#__PURE__*/React.createElement(Tooltip, {
    disabled: this.props.closed,
    content: option.label,
    alignment: "RIGHT",
    closeOnMouseClick: true
  }, /*#__PURE__*/React.createElement("label", {
    name: 'radio_' + option.value,
    className: "tabLabel"
  }, /*#__PURE__*/React.createElement(RadioButton, {
    value: option.value,
    selected: option.value === selectedValue,
    onChange: function onChange() {
      return _this.props.onChange(option.value);
    },
    showRadioSymbol: false,
    name: option.value
  }, /*#__PURE__*/React.createElement("span", {
    className: "tab-icon-text-wrapper"
  }, option.symbol ? /*#__PURE__*/React.createElement("span", {
    key: "icon",
    className: "tab-icon"
  }, option.symbol) : null, this.props.closed ? /*#__PURE__*/React.createElement("span", {
    className: "tab-text",
    key: "verticalTabCustomText"
  }, /*#__PURE__*/React.createElement(TextLabel, {
    value: option.label,
    type: "T19"
  })) : null)), this.props.closed ? /*#__PURE__*/React.createElement(Divider, {
    "long": true,
    key: "divider"
  }) : null)));
}

function scopeSelectedValue2() {
  var selectedValue = this.props.value;
  return React.createElement.apply(this, ['div', {
    className: _({
      'control-tabs-vertical-custom': true,
      closed: this.props.closed
    }).transform(function (res, value, key) {
      if (value) {
        res.push(key);
      }
    }, []).join(' ')
  }, _.map(this.props.options, repeatOption1.bind(this, selectedValue))]);
}

module.exports = function () {
  return scopeSelectedValue2.apply(this, []);
};